import React from 'react'

import { AnyType } from 'packages/types'

export const ActivityLoginContext = React.createContext<{
  schoolId?: number
  activityId?: number
}>(null as AnyType)
